<!--
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2023-02-13 09:16:22
-->
<template>
    <div>
        <router-view v-slot="{ Component, route }">
            <transition :name="route.meta.transition || 'fade'" mode="out-in">
                <!-- keep-alive影响到 故障数据图表切换tab时，没有更新视图，暂时注释掉 -->
                <!-- <keep-alive :include="props.cachedViews"> -->
                    <suspense>
                        <template #default>
                            <component
                                :is="Component"
                                :key="route.name ? route.path : undefined"
                            />
                            </template>
                        <template #fallback> Loading... </template>
                    </suspense>
                <!-- </keep-alive> -->
            </transition>
        </router-view>
    </div>
</template>

<script setup>
    const props = defineProps({
        cachedViews:{
            type:Array,
        }
    })
    // console.log(props.cachedViews,'cache')
</script>

<style lang="scss" scoped>

</style>